photos-timeline, photos-albums, photos-bin {
  height: 100%;
}

.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-buttons {
  min-width: 50px;
}

.header-button {
  min-width: 50px;
}

.photos-drop-area {
  border: 2px dashed grey !important;
  height: 100%;
}

.photos-drop-area:hover {
  border-color: green !important;
}

.scroll-container {
  height: 100%;
  overflow-y: scroll;
  padding-left: 8px;/* 10px 0 10px; */
  scrollbar-width: thin;
  scrollbar-color: grey transparent;
  scrollbar-gutter: stable;
}

.photo {
  background-size: cover;
  display: inline-block;
  vertical-align: top;
  margin: 4px;
  position: relative;
  border: 1px solid lightgray; /* Gives a photo border effect */
}

.photo .overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.5); /* 50% dark overlay */
}

.photo-album {
  display: inline-block;
  text-align: center;
  padding: 0 20px 0 20px;
}

.photo-album small {
  max-width: 100%;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.photo-stack {
  position: relative;
  margin: 20px auto; /* Center the stack horizontally */
  perspective: 800px; /* Optional: Adds a slight 3D perspective */
  aspect-ratio: 1 / 1;
}

.photo-stack .photo {
  position: absolute; /* Stack all images on top of each other */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid lightgray; /* Gives a photo border effect */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3); /* Adds a shadow for depth */
  transform-origin: center center;
  transition: transform 0.3s, box-shadow 0.3s; /* Smooth animation */
}

/* Add rotation for the stack effect */
.photo-stack .photo:nth-child(1) {
  transform: rotate(-5deg);
}

.photo-stack .photo:nth-child(2) {
  transform: rotate(5deg);
}

.photo-stack .photo:nth-child(3) {
  transform: rotate(-10deg);
}

.photo-stack .photo:nth-child(4) {
  transform: rotate(10deg);
}

/* Optional hover effect to bring the top photo forward */
.photo-stack .photo:hover {
  transform: scale(1.1) translateY(-10px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.5);
  z-index: 10; /* Ensure the hovered image is on top */
}

.center-text {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.camera-button-holder {
  margin-right: 16px;
  /* lift if above the actions footer */
  margin-bottom: var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 30px));
}

.camera-button {
  opacity: 0.7;
  width: 75px !important;
  height: 75px !important;
}
.camera-button ion-icon {
  color: black;
}

.footer-selected-info {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  border-radius: 40px;
  display: flex;
  flex-flow: row;
  white-space: nowrap;
  vertical-align: middle;
  width: max-content;
}


ion-action-sheet.album-selector .action-sheet-title {
  color: #fff;
  background-color: var(--ion-color-step-800);
}

.photo .checkbox {
  color: white;
}

/* desktop checkbox appears on hover */
@media (min-width: 576px) {
  .photo {
    width: 160px;
    height: 160px;
  }
  .photo .checkbox-hover {
    opacity: 0
  }
  .photo:hover .checkbox-hover {
    opacity: 1;
  }
  .photo-album {
    width: 160px; /* Set a fixed size for the stack */
    height: 160px;
  }
}

@media (max-width: 575.98px) {
  .photo {
    width: 60px;
    height: 60px;
  }

  .photo div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .photo-album {
    width: 50%; /* Get a 2 column layout with margin */
  }
}
